import { Box } from '@chakra-ui/layout'
import { connectNetwork } from 'lib/NetworkProvider'
import moment from 'moment-timezone'
import 'moment/locale/it'
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Input, Modal, Table } from 'semantic-ui-react'
import ListingEditor from './ListingEditor'
import { baseViewDispatch, initializePage } from '../lib/util'
import Listing from './Listing'
function Listings(props) {
    const {
        searchText,
        network,
        table,
        time,
        label,
        field,
        format,
        toolbarResult,
        filtersResult,
        sortsResult,
        deleteListing,
        mergeListing,
        sub,
        login,
    } = props
    const [showNoteEditor, setShowNoteEditor] = useState({
        show: false,
        listing: null,
    })

    const [listings, setListings] = useState([])
    const [count, setCount] = useState(0)
    const [dirty, setDirty] = useState(false)
    const [creating, setCreating] = useState(false)
    const [editing, setEditing] = useState(false)
    const [filters, setFilters] = useState({})
    const [sorts, setSorts] = useState({})
    const [page, setPage] = useState(0)
    const pageRef = useRef()
    const countRef = useRef()

    const items = 10

    pageRef.current = page
    countRef.current = count

    useEffect(() => {
        network.getListingList(searchText ? searchText : '', false, filters, sorts, page, 10).then((data) => {
            // console.log(data)

            const listings = []
            for (const key in data.data) {
                listings.push(data.data[key])
            }
            setCount(data.count)
            setListings(listings)
            setDirty(false)
        })
    }, [dirty, deleteListing.fetching, page, searchText])

    useEffect(() => {
        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        let extraTools = []
        if (user && !!user.manage_article) {
            extraTools.push({
                name: 'Crea nuovo listino',
                icon: 'add',
                action: () => {
                    setCreating(true)
                },
            })
            // extraTools.push({
            //     name: 'Importa stampi da file',
            //     icon: 'check',
            //     action: () => {
            //         this.setState({
            //             showImport: true,
            //         })
            //     },
            // })
        }

        const toolbar = sub
            ? []
            : [
                  ...extraTools,
                  {
                      name: '',
                      icon: 'arrow left',
                      position: 'right',
                      action: function () {
                          if (pageRef.current > 0) {
                              setPage(pageRef.current - 1)
                          }
                      },
                  },
                  {
                      name: '',
                      icon: 'arrow right',
                      position: 'none',
                      action: function () {
                          if (pageRef.current * 10 + 10 < countRef.current) {
                              setPage(pageRef.current + 1)
                          }
                      },
                  },
              ]

        const sortoptions = {
            listingCode: {
                name: 'listingCode',
                label: 'Codice listino',
                onChange: (obj, value) => {
                    sorts[obj.name] = value
                    setSorts(sorts)
                    setListings([])
                    setDirty(true)
                },
                onReset: (obj) => {
                    delete sorts[obj.name]
                    setSorts(sorts)
                    setListings([])
                    setDirty(true)
                },
            },
            creationDate: {
                name: 'creationDate',
                label: 'Data di creazione',
                onChange: (obj, value) => {
                    sorts[obj.name] = value
                    setSorts(sorts)
                    setListings([])
                    setDirty(true)
                },
                onReset: (obj) => {
                    delete sorts[obj.name]
                    setSorts(sorts)
                    setListings([])
                    setDirty(true)
                },
            },
        }

        const filteroptions = {
            listingCode: {
                control: Input,
                name: 'listingCode',
                input: 'text',
                placeholder: 'Codice listino',
                label: 'Codice listino',
                onChange: (e) => {
                    filters.listingCode = { value: e.target.value, key: 'listingCode', operator: '=' }
                    setFilters(filters)
                    setDirty(true)
                },
                onReset: () => {
                    setFilters(filters)
                    setListings([])
                    setDirty(true)
                },
            },
            listingName: {
                control: Input,
                name: 'listingName',
                input: 'text',
                placeholder: 'Nome listino',
                label: 'Nome listino',
                onChange: (e) => {
                    filters.listingName = { value: e.target.value, key: 'listingName', operator: '=' }
                    setFilters(filters)
                    setDirty(true)
                },
                onReset: () => {
                    setFilters(filters)
                    setListings([])
                    setDirty(true)
                },
            },
        }

        initializePage({ props: { toolbarResult, filtersResult, sortsResult } }, toolbar, filteroptions, sortoptions)
    }, [])

    return (
        <>
            <Box ml={16} mt={4}>
                Visualizzando {page * items} - {page * items + items} su {count}
            </Box>
            {listings && listings.length && (
                <Table celled sortable>
                    <Listing
                        type="header"
                        sorts={sorts}
                        onListingCodeHeaderClick={() => {
                            if (!sorts.listingCode) {
                                sorts.listingCode = 'asc'
                            } else if (sorts.listingCode === 'asc') {
                                sorts.listingCode = 'desc'
                            } else {
                                delete sorts.listingCode
                            }
                            setSorts(sorts)
                            setListings([])
                            setDirty(true)
                        }}
                    />
                    <Table.Body>
                        {listings.map((value, index) => {
                            return (
                                <Listing
                                    key={value.listingId}
                                    type="table"
                                    listing={value}
                                    onRowClick={(state) => {
                                        const { listingId } = state
                                        setEditing(listingId)
                                    }}
                                />
                            )
                        })}
                    </Table.Body>
                </Table>
            )}

            <Modal
                closeIcon
                open={!!editing || !!creating}
                onClose={() => {
                    setEditing(false)
                    setCreating(false)
                }}
            >
                <Modal.Header>{creating ? 'Creando listino' : 'Modificando listino'}</Modal.Header>
                <Modal.Content>
                    <ListingEditor
                        listingId={creating ? null : editing}
                        onSave={(listing) => {
                            setEditing(false)
                            setCreating(false)
                            setListings([])
                            setDirty(true)
                        }}
                        onCancel={() => {
                            setEditing(false)
                            setCreating(false)
                        }}
                    />
                </Modal.Content>
            </Modal>
        </>
    )
}

const mapStateToProps = (state, ownProps) => {
    let {
        getMachineList,
        deleteListing,
        login,
        search: { data: searchText },
    } = state

    return {
        getMachineList,
        deleteListing,
        login,
        searchText,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...baseViewDispatch(dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(Listings)))
